import React, { useEffect } from 'react';
import useCurrentUser from '../hooks/useCurrentUser';
import { EUserType } from '../data_models/enums';
import FreelancerDashboard from '../components/dashboard/FreelancerDashboard';
import EmployerDashboard from '../components/dashboard/EmployerDashboard';
import useRouting from '../hooks/useRouting';



const DashboardPage: React.FC = () => {


  const { currentUser, currentUserType, isLoggedIn } = useCurrentUser();

  const { goToSignup } = useRouting();

  useEffect(() => {
    if (!isLoggedIn) {
      goToSignup();
    }
  }, [currentUserType]);


  return (
    <>
      {!currentUser ? (
        <div className="p-4 max-w-7xl mx-auto">
          <h3 className='font-bold'>Please login to continue...</h3>
        </div>
      ) : (
        <div className="p-4 max-w-7xl mx-auto">
          {/* Temporary message to users */}
          <div className="mx-auto p-4 border border-primary rounded-xl bg-neutral-100 text-primary">
            <p className="">Thank you for joining Gamers Home! We're continuously updating the platform to make it even better. Expect improvements soon for a smoother experience!</p>
            <p className="mt-3">
              Grow with us, and share your feedback by emailing us at
              <a href="mailto:info@gamershome.studio"> info@gamershome.studio </a>
              or joining the discussions in our
              <a href="https://discord.gg/tgphBagzWE" target="_blank" rel="noopener noreferrer" > Discord </a>
              community.
            </p>
          </div>

          <>

            {(isLoggedIn && currentUserType === EUserType.FREELANCER)
              ? <div className='w-full '><FreelancerDashboard /></div>
              : (isLoggedIn && currentUserType === EUserType.EMPLOYER)
                ? <div className='w-full '>
                  <EmployerDashboard />
                </div>
                : <div className='flex flex-col items-center w-full my-10'>
                  <h1>You need to be logged in to access this page</h1>
                </div>
            }

          </>
        </div>
      )}
    </>
  );
};

export default DashboardPage;